import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import serviceBanner from "../../../assets/service/BannerSection.jpg";
import slider1 from "../../../assets/All Images/Buiness Software section 5 image.png";
import { Link } from "react-router-dom";
import axios from "axios";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import CanadaFooter from "../../Components/Footer";
import Shape2 from "../../../assets/brand/choose-shape-2.png";

import "react-modal-video/scss/modal-video.scss";

import secOneImg2 from "../../../assets/canada/Business-Audit/Bus-Audit-sec-1-2.jpg";
import secOneImg3 from "../../../assets/canada/Business-Audit/Bus-Audit-sec-1-3.jpg";
import section6Image from "../../../assets/All Images/business software section 6 image .png";

import laptopImg from "../../../assets/canada/Business-Audit/Bus-Audit-Sec-5.jpg";

const CanadaGapAnalysis = () => {
  const [description, setDescription] = useState([]);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get(
          "https://mars.zithas.com/api/currentopening/wordpress-developer"
        );
        setDescription(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetch();
  }, []);

  return (
    <div>
      <Helmet>
        <title>
        Business Software Audit Company in USA | Zithas Technologies
        </title>
        <meta
          name="description"
          content="Get a comprehensive business software audit in USA. Ensure your systems are optimized for success with expert analysis and solutions."
        />
        <meta
          name="keywords"
          content="business software audit, business software audit USA"
        />
      </Helmet>
      <CanadaHeader1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#4a026c" }}
                >
                  Business Software Audit
                </h2>
                <p style={{ color: "black" }}>
                  Spotting Expansion Avenues and Guiding Your Business to Reach
                  Its Maximum Potential.
                </p>
                <div className="breadcrumb-menu"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First Section */}
      {/* <Choose1 /> */}
      <div>
        <section className="bd-choose-area fix pb-0 pt-80">
          <div className="container" style={{ maxWidth: "1270px" }}>
            <div className="bd-choose-shape">
              <div className="row">
                <div className="col-xl-6 col-lg-6 order-2 order-lg-1">
                  <div className="bd-choose-text  z-index">
                    <div className="bd-section-title-wrapper mb-25">
                      {/* <h5 className="bd-section-subtitle mb-15">Why Choose Us</h5> */}
                      <h2 className="bd-section-title mb-15">
                      Business Software Audit
                      </h2>
                    </div>

                    <p style={{ width: "95%", fontSize: "18px" }}>
                    Spotting Expansion Avenues and Guiding Your Business to Reach Its Maximum Potential.
                    When business software gets too complicated, everything slows down. Teams struggle to get things done, new hires need extra time to learn the system, and small mistakes start to snowball. The more complex it gets, the more time and money you lose—not to mention the daily frustration it brings.
                    </p>
                    <p style={{ width: "95%", fontSize: "18px" }}>
                    That’s why a Business Software Audit can be a game-changer. It helps you spot what’s broken, uncover hidden inefficiencies, and find ways to work smarter—not harder. From saving costs to making everyday tasks easier, it’s the first step toward smoother, faster, and smarter operations that truly support your growth.
                    </p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                  <div className="bd-choose-img text-end  z-index">
                    <div className="row align-items-center media-respon-digital custom-mar-15">
                      <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                        <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                          <img
                            src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747308407/USA%20website/BUSINESS%20SOFTWARE%20AUDIT/Business_Software_1_ajgcnm.png"
                            className="resp-img bordertop-img1"
                            alt="img not found"
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                        <div className="bd-choose-img-inner mb-15">
                          <img
                            src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747308455/USA%20website/CUSTOM%20SOFTWARE%20DEVELOPMENT/Custom_Software_1_uioour.png'}
                            className="resp-img bordertop-img2"
                            alt="img not found"
                          />
                        </div>
                        <div className="bd-choose-img-inner mb-15">
                          <img
                            src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747308405/USA%20website/BUSINESS%20SOFTWARE%20AUDIT/Business_Software_2_vcv1vl.png'}
                            className="resp-img bordertop-img3"
                            alt="img not found"
                          />
                        </div>
                      </div>
                    </div>
                    <img
                      className="bd-choose-shape bd-choose-shape-2"
                      src={Shape2}
                      alt="shape img not found"
                    />
                  </div>
                </div>  
              </div>
            </div>
          </div>
        </section>

      </div>

      {/* Second Section */}
      <section className="bd-choose-area fix">
        <div className="container" style={{ maxWidth: "1300px" }}>
          <div className="bd-choose-shape">
            <div className="row ">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 first_resp_audit">
                {/* <div className="ablog ablog-4 mb-60"> */}
                <div className="bd-choose-text mb-30 z-index">
                  <div className="bd-section-title-wrapper mb-35">
                    <h2 className="bd-section-title title_resp mb-15 ml-15">
                      <span style={{ color: "#ffbf1e" }}>
                        Business Software Audit
                      </span>{" "}
                      <br />
                      Is Not Just a Process !
                    </h2>

                    <p className="ml-15 para_one">
                    Business automation is no longer optional—it’s essential. By blending smart tools with strategic thinking, automation takes the weight off daily tasks so your team can focus on what truly matters. Whether it’s managing emails, tracking leads, or syncing data across platforms, automation simplifies it all.
                    </p>
                    <h4 className="ml-15 para_one">
                      Business Software Audit: Not just a process, but a new
                      perspective!
                    </h4>
                    <p className="ml-15 para_one">
                    At Zithas, we bring you the best-fit automation systems tailored to your business. Whether you're just starting out or scaling fast, our solutions are designed to boost efficiency, reduce manual errors, and increase profitability—without the overwhelm.
                    </p>
                  </div>
                  <div></div>
                </div>
                {/* </div> */}
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mt-0 second_resp_audit">
                <div className="bd-choose-img mb-30 z-index mt-125">
                  <div className="bd-choose-info-wrapper">
                    <div className="container text-center">
                      <div className="row mb-50">
                        <div className="col cell_resp mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440198/website/icons/Data-Collection_nchwqi.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Improved User Experience
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div
                              className="bd-choose-info-icon mb-15"
                              style={{ color: "#5e5858" }}
                            >
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440198/website/icons/Data-Analysis_c2nxvo.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Data Accuracy and Consistency
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container text-center ">
                      <div className="row second_flex ">
                        <div className="col cell_resp cell_padd_resp mr-50">
                          <div className="animate-hover">
                            <div
                              className="bd-choose-info-icon mb-15 "
                              style={{ color: "#5e5858" }}
                            >
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440198/website/icons/Buisness-Planning_asrnre.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Improving Your Business Planning
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-20">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440198/website/icons/automated-process-64_f0p7gm.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Automated work process
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Thrid section */}
      <div className="container mt-0" style={{ maxWidth: "1250px" }}>
        <h2 className="pb-2">What We Follow :</h2>
        <div className="row three_section_resp">
          <div className="col-sm" style={{ color: "black" }}>
            <div className="top-border-line"></div>
            <div
              className="bd-about-text-five-fact"
              data-animation="fadeInUp"
              data-delay="1.1s"
            >
              <div className="section-number pb-30">01</div>
              <h4
                className="bd-slider-fact-title text-heading pb-30"
                style={{ fontSize: "26px" }}
              >
                Business Process and Rules
              </h4>
              <span
                className="bd-slider-fact-subtitle"
                style={{ color: "#5e5858" }}
              >
                Striking the right balance between rules and business processes
                is paramount for companies. An overabundance of one can
                compromise the effectiveness of the other.
              </span>
            </div>
          </div>
          <div className="col-sm ml-40 block_two " style={{ color: "black" }}>
            <div className="top-border-line"></div>
            <div
              className="bd-about-text-five-fact"
              data-animation="fadeInUp"
              data-delay="1.1s"
            >
              <div className="section-number pb-30">02</div>
              <h4
                className="bd-slider-fact-title text-heading pb-30"
                style={{ fontSize: "26px" }}
              >
                Software architecture used in systems
              </h4>
              <span
                className="bd-slider-fact-subtitle"
                style={{ color: "#5e5858" }}
              >
                Most software systems are developed with a singular objective,
                custom-crafted to address specific functional domains.
              </span>
            </div>
          </div>
          <div className="col-sm ml-40 block_two" style={{ color: "black" }}>
            <div className="top-border-line"></div>
            <div
              className="bd-about-text-five-fact"
              data-animation="fadeInUp"
              data-delay="1.1s"
            >
              <div className="section-number pb-30">03</div>
              <h4
                className="bd-slider-fact-title text-heading pb-30"
                style={{ fontSize: "26px" }}
              >
                Data access mechanisms and structures
              </h4>
              <span
                className="bd-slider-fact-subtitle"
                style={{ color: "#5e5858" }}
              >
                A data access mechanism acts as a conduit for internal data
                exchange between two separate software applications.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Fourth Section */}
      <section className="bd-slider-area pt-80" style={{ height: "700px" }}>
        <div className="bd-slider-actives" style={{ height: "700px" }}>
          <div className="swiper-wrappers" style={{ height: "700px" }}>
            <div className="bd-single-slider bd-slider-height bd-single-slider-overlay-invisible d-flex align-items-center swiper-slides">
              <div className="bd-slide-bg">
              
              </div>
              <div className="bd-slide-shape">
                <img
                  src={'https://cdn.pixabay.com/photo/2020/05/18/08/05/new-york-5185104_960_720.jpg 1x, https://cdn.pixabay.com/photo/2020/05/18/08/05/new-york-5185104_1280.jpg'}
                  style={{
                    height: "700px",
                    width: "3000px",
                    backgroundColor: "rgba(0,0,0,0.7)",
                  }}
                  alt="img not found"
                />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="bd-slider-two z-index mb-200 pb-20">
                      <h1
                        className="bd-slider-title-two mb-25 wow fadeInUp"
                        data-wow-delay=".2s"
                        style={{ color: "#c89fdb", fontSize: "84px" }}
                      >
                        Revolutionary Strategies for Business Operations
                      </h1>
                      <h4
                        className="bd-slider-subtitle-two mb-45 wow fadeInUp"
                        style={{}}
                        data-wow-delay=".4s"
                      >
                        With our consulting services, you gain a comprehensive
                        insight into your business, enabling you to harness its
                        full potential.
                      </h4>
                      <div
                        className="bd-slider-btn  wow fadeInUp"
                        data-wow-delay=".6s"
                      >
                        <Link
                          to={"/about-us"}
                          className="theme-btn theme-btn-rounded"
                        >
                          About US
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fifth Section */}
      <section className="bd-slider-area fix">
        <div className="bd-slider-actives">
          <div className="swiper-wrappers">
            <div
              className="bd-single-slider gray-bg bd-slider-height w-full position-relative pt-80 pb-80"
              style={{ minHeight: "0px" }}
            >
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="row align-items-center">
                  <div className="col-xl-7">
                    <div className="bd-slider-six">
                      <h1
                        className="bd-slider-six-title  sixth-title mb-15 wow fadeInUp"
                        data-wow-delay=".2s"
                      >
                        Harnessing the Power of{" "}
                        <span style={{ color: "#ffbf1e" }}>
                          Software Audits
                        </span>
                        <br /> for Your Company
                      </h1>
                      <p
                        className="mb-20 para_resp_one"
                        style={{ fontSize: "18px" }}
                      >
                        In the context of a Software Audit for your company,
                        there exists the capability to uncover and eliminate
                        wastage, inefficiencies, risks, unmet expectations, and
                        prospects for growth. Its primary goal is to encourage a
                        sustainable level of innovation by recognizing
                        substantial disparities between the current state of
                        systems and procedures and the company's vision for
                        achieving excellence.
                      </p>
                      <p
                        className="para_resp_one"
                        style={{ width: "95%", fontSize: "18px" }}
                      >
                        The outcomes of a Business Software Audit can provide
                        essential inputs for data-driven decision-making
                        processes. These insights can be harnessed in various
                        capacities, including ROI evaluation and risk management
                        decisions.
                      </p>
                    </div>
                  </div>

                  <div className="col-xl-5">
                    <div className="bd-slider-six-img">
                      <img
                        src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747195959/USA%20website/WEBSITE%20DEVELOPMENT/Website_Development_2_jcspzt.jpg'}
                        className="rounded-10"
                        alt="img not found"
                      />
                     <img
                      src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747207994/USA%20website/BUSINESS%20SOFTWARE%20AUDIT/section_6_image_bsnjzy.png'}
                      className="bd-slider-six-img-shape1"
                      alt="img not found"
                    />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sixth Section */}
      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section ">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Seeking a Business Software Audit Expert in USA?
                </h2>
                <p className="contact_section second-para-resp">
                  You're here at the right moment.
                </p>
                <p className="contact_subtext">
                  Outstanding Analyst, Let's Begin Without Delay!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30" style={{alignItems: "center"}}>
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                   
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+1 (647) 446-9073"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                     +1 (647) 446-9073
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <CanadaFooter />
    </div>
  );
};

export default CanadaGapAnalysis;
